export const TEMPLATE_PATH = "/modelos/planilha-transparencia.csv";

const FIRST_YEAR = 2026;

export function availableYears(today: Date = new Date()): number[] {
  const years: number[] = [];
  for (let year = FIRST_YEAR; year <= today.getFullYear() + 1; year += 1) {
    years.push(year);
  }
  return years;
}
